export const NUM_VAR = 32;
export const NUM_BAR = 32;

export const MIN_DELAY_SEC = 0.02;
export const CHORD_MS = 2;

export const MIDI_CHANNEL = 0;
export const SOUNDFONT_PRESET = 1;
export const DEFAULT_VELOCITY = 100;

export const LOOKAHEAD_SEC = 0.1;
export const TICK_MS = 25;

export const PI_2 = Math.PI / 2;

export const SF2_URL = 'soundfont/RolandNicePiano.sf2';
export const FLUIDSYNTH_JS_URL = 'fluidsynth/libfluidsynth-2.4.6.js';
export const JSSYNTH_WORKLET_URL = 'fluidsynth/js-synthesizer.worklet.min.js';

export const STORAGE_KEYS = {
  loop: 'gv.loop',
  linear: 'gv.linear',
  invertPitch: 'gv.invertPitch',
} as const;

export const clamp = (v: number, lo: number, hi: number): number =>
  v < lo ? lo : v > hi ? hi : v;

export const deg2rad = (d: number): number => (d * Math.PI) / 180;
